
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.65 22.92c0-1.23.17-2.51-.66-3.53a5.37 5.37 0 00-3.26-1.52L31 15.39a18.42 18.42 0 00-.87-2.94c-.67-1.37-2.06-1.32-3.33-1.32h-2.4c-.2-1.4-1.59-1.92-2.88-1.92H7.7c-1.07 0-2.16-.08-2.93.86-.63.77-.48 1.85-.48 2.79v14.09a2 2 0 00.76 1.68 3.35 3.35 0 002.13.4 4.72 4.72 0 00.26 1 3.6 3.6 0 003.49 2.31A3.65 3.65 0 0014.09 29h11.84a4.33 4.33 0 00.26 1 3.6 3.6 0 003.49 2.31A3.67 3.67 0 0032.85 29a3.13 3.13 0 001.8-.33 2.18 2.18 0 001-1.85c.04-1.32 0-2.62 0-3.9zm-8.74-10.69c.6 0 1.87-.29 2.14.34a28.35 28.35 0 01.86 3l.52 1.81-1.27.15a13.59 13.59 0 01-2.3 0c-.82-.05-1.64-.14-2.46-.23v-5.07zm-16 18.71a1.72 1.72 0 01-1.25-.05 1.79 1.79 0 01-.47-.3 2.51 2.51 0 01-.4-.55A3.14 3.14 0 019 26.92a2.19 2.19 0 012.45-1 1.89 1.89 0 01.94.86 3.06 3.06 0 01.32 1.81 2.83 2.83 0 01-1.77 2.35zm3.18-3.12a4 4 0 00-2-2.92 3.23 3.23 0 00-3.95.68 3.89 3.89 0 00-1 2.25c-.57 0-1.14-.07-1.37-.65a2.27 2.27 0 01-.08-.82v-11.2h8.4a5.43 5.43 0 002.59-.58c.15-.08.5-.25.45-.47s-.47-.24-.61-.24h-9a6 6 0 00-1.78.26v-.27a22.11 22.11 0 010-2.7c.1-.87.76-.76 1.44-.76h13.25c1.11 0 2.61-.14 2.61 1.5a.4.4 0 00.06.21v15.71h-9zm15.57 3.12a1.72 1.72 0 01-1.25-.05 1.79 1.79 0 01-.47-.3 2.51 2.51 0 01-.4-.55 3.14 3.14 0 01.2-3.12 2.19 2.19 0 012.45-1 1.89 1.89 0 01.94.86 3.06 3.06 0 01.32 1.81 2.83 2.83 0 01-1.76 2.35zm4.66-4.88a1.75 1.75 0 01-.74 1.55 1.63 1.63 0 01-.78.25 4 4 0 00-2-2.95 3.23 3.23 0 00-3.95.68 4 4 0 00-1 2.23H24.4v-9.29c1 .12 2.05.23 3.08.29a14 14 0 002.33 0l1.33-.16.18.08c.88.22 2.59.3 2.92 1.3a9.85 9.85 0 01.08 2.82c.03 1.07.05 2.14.03 3.2z"}})])
          )
        }
      }
    